import React, { useEffect, useMemo, useState } from "react";
import { Box } from "@mui/material";
import NavTabs from "../../../../../../components/Tabs/NavTabs";
import EditingTables from "./editingTables";
import { listTables, getTableRows, updateTableRow } from "./clientDataApi";

const DB_TABS = [
  { label: "Piping", dbName: "piping" },
  { label: "Structure", dbName: "structure" },
  { label: "Pressure Vessel", dbName: "pv" },
];

const tableApi = {
  getItems: (tableName, dbName) => getTableRows(dbName, tableName),
  updateItem: (item, tableName, dbName) => updateTableRow(dbName, tableName, item),
};

export default function ClientDataEditingPage() {
  const [tablesByDb, setTablesByDb] = useState({});

  useEffect(() => {
    DB_TABS.forEach(({ dbName }) => {
      listTables(dbName)
        .then((names) => setTablesByDb((prev) => ({ ...prev, [dbName]: names })))
        .catch((error) => {
          console.error(`Failed to list tables for "${dbName}":`, error);
          setTablesByDb((prev) => ({ ...prev, [dbName]: [] }));
        });
    });
  }, []);

  const mainTabs = useMemo(
    () =>
      DB_TABS.map(({ label, dbName }) => {
        const tableOptions = tablesByDb[dbName] || [];
        return {
          label,
          panel: (
            <EditingTables
              title="Tables"
              tableOptions={tableOptions}
              dbTab={dbName}
              tableApi={tableApi}
            />
          ),
        };
      }),
    [tablesByDb]
  );

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        pt: 2,
        width: "100%",
      }}
    >
      <Box sx={{ width: "100%" }}>
        <NavTabs
          navLabel="editing-tables-main"
          tabs={mainTabs}
          tabProps={{ variant: "scrollable", scrollButtons: "auto" }}
        />
      </Box>
    </Box>
  );
}
